import { useGetList, useTimeout } from "ra-core";
import { Skeleton } from "@/components/ui/skeleton";

import type { Contact, ContactNote } from "../types";
import { DashboardActivityLog } from "./DashboardActivityLog";
import { DashboardMetrics } from "./DashboardMetrics";
import { DashboardStepper } from "./DashboardStepper";
import MobileHeader from "../layout/MobileHeader";
import { MobileContent } from "../layout/MobileContent";
import { useConfigurationContext } from "../root/ConfigurationContext";

const Wrapper = ({ children }: { children: React.ReactNode }) => {
  const { darkModeLogo, lightModeLogo, title } = useConfigurationContext();
  return (
    <>
      <MobileHeader>
        <div className="flex items-center gap-2 py-3 text-secondary-foreground">
          <img
            className="h-6 [.light_&]:hidden"
            src={darkModeLogo}
            alt={title}
          />
          <img
            className="h-6 [.dark_&]:hidden"
            src={lightModeLogo}
            alt={title}
          />
          <h1 className="text-xl font-semibold">{title}</h1>
        </div>
      </MobileHeader>
      <MobileContent>{children}</MobileContent>
    </>
  );
};

const Loading = () => (
  <Wrapper>
    <Skeleton className="mb-4 h-20 w-full" />
    <Skeleton className="mb-2 h-4 w-full" />
    <Skeleton className="mb-2 h-4 w-full" />
  </Wrapper>
);

export const MobileDashboard = () => {
  const contacts = useGetList<Contact>("contacts", {
    pagination: { page: 1, perPage: 1 },
  });
  const notes = useGetList<ContactNote>("contact_notes", {
    pagination: { page: 1, perPage: 1 },
  });
  const oneSecondHasPassed = useTimeout(1000);

  if (contacts.isPending || notes.isPending) {
    return oneSecondHasPassed ? <Loading /> : null;
  }

  return (
    <Wrapper>
      <div className="flex flex-col gap-6">
        <DashboardMetrics />
        {!contacts.total ? (
          <DashboardStepper step={1} />
        ) : !notes.total ? (
          <DashboardStepper step={2} contactId={contacts.data?.[0]?.id} />
        ) : (
          <DashboardActivityLog />
        )}
      </div>
    </Wrapper>
  );
};
